import React from 'react';
import { Button } from '@densityco/ui';

const DetailsButton: React.FunctionComponent<{
  href: string;
  size?: 'small' | 'large';
}> = ({ href, size }) => (
  <Button
    href={href}
    size={size}
    target="_blank"
    rel="noopener noreferrer"
    onMouseDown={(e) => e.stopPropagation()}
    onClick={(e) => e.stopPropagation()}
  >
    Details
  </Button>
);

export default DetailsButton;
